import React, { useEffect, useState } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import DataTable from "react-data-table-component";
import { Spinner } from "react-bootstrap";
import { Eye } from "react-feather";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import { useParams } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Link } from "react-router-dom";

const AdminSellerOrders = () => {
  const { id } = useParams(); // Use this if you navigate to /admin/customer-orders/:user_id
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await axios.get(`${baseurl}getOrdersBySellerId/${id}`);

        console.log("response", response);

        if (response.data.success) {
          setOrders(response.data.orders || []);
        }
      } catch (error) {
        console.error("Error fetching orders:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [id]);



  

  const columns = [
    {
      name: "Order ID",
      selector: (row) => row.order_unique_id,
      sortable: true,
    },
    {
      name: "Payment Method",
      selector: (row) => row.payment_method,
    },
    
    {
      name: "Total (₹)",
      selector: (row) => row.total,
    },
    
    {
      name: "Created At",
      selector: (row) => new Date(row.created_at).toLocaleString(),
    },
    
    {
        name: "Actions",
        cell: (row) => (
          <a href={`/performa-invoice-admin/${row.order_unique_id}`} target="_blank" className="btn btn-primary btn-sm">
            <Eye size={16} /> View Invoice
          </a>
        ),
      }
      
  ];



  const exportToExcel = () => {
    const dataToExport = orders.map(order => {
      const items = order.cart_items?.map(ci => `${ci.title} x ${ci.quantity}`).join(", ");
      return {
        OrderID: order.order_unique_id,
        PaymentMethod: order.payment_method,
        Status: order.status,
        Total: order.total,
        PaymentStatus: order.payment_status,
        CreatedAt: new Date(order.created_at).toLocaleString(),
        Items: items
      };
    });
  
    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");
  
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, `CustomerOrders_${id}.xlsx`);
  };

  
  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid text-start">
          <h4 className="mb-3">Seller Orders</h4>
          <div className="card">
          <div className="d-flex justify-content-end p-2">
  <button className="btn btn-success btn-sm" onClick={exportToExcel}>
    Download Excel
  </button>
</div>
            <div className="card-body" style={{ padding: 0 }}>
              {loading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
                  <Spinner animation="border" />
                </div>
              ) : (
                <DataTable
                  columns={columns}
                  data={orders}
                  pagination
                  highlightOnHover
                  responsive
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSellerOrders;
